import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center mt-2" }
const _hoisted_2 = { class: "modal-body mx-4" }
const _hoisted_3 = { class: "confirmation-modal-note" }
const _hoisted_4 = { class: "my-5" }
const _hoisted_5 = { class: "pl-3 mb-5" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "pl-3" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "d-flex justify-content-end m-3 mt-4" }

import i18n from '@/lang/i18n';
import { GDialog } from 'gitart-vue-dialog'
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UnexpectedEventConfirmModal',
  props: {
    modelValue: { type: Boolean },
    confirm: { type: Function }
  },
  emits: ['update:modelValue', 'cancel', 'openModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

const FIRST_MESSAGES = [
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of1',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of2',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of3',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no1of4'
]

const SECOND_MESSAGES = [
  'pages.dailyReports.unexpectedEventConfirmModal.messages.example',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of1',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of2',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of3',
  'pages.dailyReports.unexpectedEventConfirmModal.messages.no2of4'
]

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    transition: "custom-from-bottom-transition",
    persistent: true,
    "max-width": "45%"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventConfirmModal.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventConfirmModal.messages.no1')), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FIRST_MESSAGES, (message) => {
                return _createElementVNode("div", {
                  key: message,
                  textContent: _toDisplayString(_unref(i18n).global.t(message))
                }, null, 8, _hoisted_6)
              }), 64))
            ]),
            _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.unexpectedEventConfirmModal.messages.no2')), 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(SECOND_MESSAGES, (message) => {
                return _createElementVNode("div", {
                  key: message,
                  style: {"white-space":"pre-wrap"},
                  textContent: _toDisplayString(_unref(i18n).global.t(message))
                }, null, 8, _hoisted_8)
              }), 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_v_btn, {
          class: "ma-2 reset-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.return')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          class: "ma-2 exec-btn",
          onClick: props.confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.confirmBtn')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})